import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { FootballMatchDetail } from "../../../../../../commons/models/football/football-match-detail";
import { manageFootballSeasonService } from "../../../../../../commons";
import { MatchStatusEnum } from "../../../../../../commons/enums/match-status-enum";

export interface IFootballMatchState {
  seasonMatchDetail: FootballMatchDetail;
  seasonMatchDetailStatus: StatusEnum;
}

export interface IManageSeasonMatchOption {
  seasonId: number;
  matchId: number;
  urlParams?: {
    hostTeamId?: number;
    competitionId?: number;
    status?: MatchStatusEnum;
  };
}

const initialState: IFootballMatchState = {
  seasonMatchDetail: new FootballMatchDetail(),
  seasonMatchDetailStatus: StatusEnum.Idle,
};

export const fetchSeasonMatchDetail = createAsyncThunk(
  "manage/seasonMatchDetail",
  async (options: IManageSeasonMatchOption, thunkAPI) => {
    try {
      const seasonMatchDetail = await manageFootballSeasonService.getSeasonMatch(
        options.seasonId,
        options.matchId,
        options?.urlParams
      );
      seasonMatchDetail.competitionId = seasonMatchDetail.competition.id;
      return seasonMatchDetail;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballSeasonMatchDetailSlice = createSlice({
  name: "footballMatchDetail",
  initialState: initialState,
  reducers: {
    cleanUpSeasonMatch(state) {
      state.seasonMatchDetail = new FootballMatchDetail();
      state.seasonMatchDetailStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSeasonMatchDetail.pending, (state) => {
        state.seasonMatchDetailStatus = StatusEnum.Loading;
      })
      .addCase(fetchSeasonMatchDetail.fulfilled, (state, action: PayloadAction<FootballMatchDetail>) => {
        state.seasonMatchDetailStatus = StatusEnum.Succeeded;
        state.seasonMatchDetail = action.payload;
      })
      .addCase(fetchSeasonMatchDetail.rejected, (state) => {
        state.seasonMatchDetailStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSeasonMatch } = footballSeasonMatchDetailSlice.actions;
export default footballSeasonMatchDetailSlice.reducer;
